import { HistoryEvent } from "./tactics.model";
export class BeyondTopPlayer {
    constructor(name, nrOfLives, nrOfRounds) {
        this.rounds = [];
        this.averageScore = '0';
        this.name = name;
        this.totalPoints = 0;
        this.lives = nrOfLives;
        this.eliminated = false;
        for (let i = 1; i <= nrOfRounds; i++) {
            this.rounds.push(new BeyondTopRound(i, ''));
        }
    }
}
export class BeyondTopRound {
    constructor(round, hit) {
        this.round = round;
        this.hit = hit;
    }
}
export class BeyondTopHistoryEvent extends HistoryEvent {
    constructor(type, playerName, playerIndex, segment, score, previousScore, points, lives, eliminated) {
        super(type, playerIndex, segment);
        this.playerName = playerName;
        this.score = score;
        this.previousScore = previousScore;
        this.eliminated = eliminated;
        this.points = points;
        this.lives = lives;
    }
}
